import React, { useState, useEffect } from "react";
import { useAuth } from "../../contexts/AuthContext";
import Sidebar from "../Navigations/Sidebar";
import AccountApiClient from "../../services/AccountApiClient";
import BusinessList from "./BusinessList";
import AddEditBusiness from "./AddEditBusiness";
import usePageTitle from "../../hooks/usePageTitle";

interface Business {
  id: string;
  name: string;
}

const BusinessSetup: React.FC = () => {
  const { user } = useAuth();
  const [businesses, setBusinesses] = useState<Business[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [isAddEditOpen, setIsAddEditOpen] = useState(false);
  const [selectedBusiness, setSelectedBusiness] = useState<Business | null>(
    null
  );

  usePageTitle("Business Setup");

  // Fetch businesses on component mount
  useEffect(() => {
    fetchBusinesses();
  }, []);

  const fetchBusinesses = async () => {
    setLoading(true);
    setError(null);

    try {
      const businessData = await AccountApiClient.fetchBusinesses();
      setBusinesses(businessData);
    } catch (error) {
      console.error("Error fetching businesses:", error);
      setError("Failed to fetch businesses");
    } finally {
      setLoading(false);
    }
  };

  const handleRefresh = () => {
    fetchBusinesses();
  };

  const handleAddBusiness = () => {
    setSelectedBusiness(null);
    setIsAddEditOpen(true);
  };

  const handleEditBusiness = (business: Business) => {
    setSelectedBusiness(business);
    setIsAddEditOpen(true);
  };

  const handleCloseAddEdit = () => {
    setIsAddEditOpen(false);
    setSelectedBusiness(null);
  };

  const handleSaveAddEdit = () => {
    // Refresh the business list after adding/editing
    fetchBusinesses();
  };

  // Check if user has Root access
  if (user?.role !== "Root") {
    return (
      <div className="app-layout">
        <Sidebar currentPage="/business-setup" />
        <div className="main-content">
          <div className="page-header">
            <h2>🏢 Business Setup</h2>
            <p style={{ color: "red" }}>
              Access denied. Root privileges required.
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="app-layout">
      <Sidebar currentPage="/business-setup" />

      <div className="main-content">
        <div className="page-header">
          <h2>🏢 Business Setup</h2>
          <p>Manage all businesses in the system</p>
        </div>

        <BusinessList
          businesses={businesses}
          loading={loading}
          error={error}
          onRefresh={handleRefresh}
          onAddBusiness={handleAddBusiness}
        />

        <AddEditBusiness
          isOpen={isAddEditOpen}
          onClose={handleCloseAddEdit}
          onSave={handleSaveAddEdit}
          business={selectedBusiness}
        />
      </div>
    </div>
  );
};

export default BusinessSetup;
